<template>
  <div class="page-content have-btns">
    <Table-Search ref="tableSearch"
      :searchs="searchs"
      @submitSearch="submitSearch"
      @resetSearch="resetSearch">
    </Table-Search>
    <Table-Table ref="tableTable"
      :tableColumns="tableColumns"
      :tableRequest="tableRequest"
      :pageLayout="pageLayout">
      <!-- 表格向下展开的内容插槽 -->
      <template slot="expand"
        slot-scope="scope">
        <el-tag size="medium">{{ scope.row.content }}</el-tag>
      </template>
    </Table-Table>

  </div>
</template>

<script>
// import { TableSearch } from 'vue-common-laboratory'
// import { TableTable } from 'vue-common-laboratory'
import moment from 'moment'
export default {
  components: {
    TableSearch: () => import('vue-common-laboratory/src/components/Table/TableSearch'),
    TableTable: () => import('vue-common-laboratory/src/components/Table/TableTable')
  },
  data() {
    return {
      pageLayout: 'total, sizes, prev, pager, next, jumper',
      searchs: [
        { type: 'input', id: 'content', label: '公告内容' },
        {
          type: 'datePicker', id: 'noticeDateStart', label: '公告开始日期',
          'picker-options': {
            disabledDate: (date) => {
              return this.disabledDateStart(date)
            }
          }
        },
        {
          type: 'datePicker', id: 'noticeDateEnd', label: '公告结束日期',
          'picker-options': {
            disabledDate: (date) => {
              return this.disabledDateEnd(date)
            }
          }
        },
      ],
      tableRequest: {
        apiModule: 'courseManage',
        apiFun: 'getCourseNoticePageForCourseDetail',
        form: {
          "content": "",
          "courseId": this.$route.query.id,
          "noticeDateEnd": "",
          "noticeDateStart": "",
        }
      },
      tableColumns: [
        { type: 'expand', width: '35px' },
        { label: '公告内容', prop: 'content', minWidth: '150%' },
        { label: '发布人', prop: 'createUserName' },
        { label: '发布时间', prop: 'createDate' },
        { label: '公告范围', prop: 'noticeRangeName' },
        // { label: '操作', prop: 'handle', width: '180px', slot: true, align: 'left' },
      ],
      positionList: [],
      dialogVisible: false,
      detail: {},
      dialogType: ''
    }
  },
  props: {
    activeName: {
      type: String
    }
  },
  watch: {
    activeName(val) {
      if (val.activeName == 'third') {
        this.$refs.tableSearch.updateSearchAuth()
      }
    }
  },
  mounted() {
  },
  methods: {
    // 日期限制
    disabledDateStart(date) {
      if (this.$refs.tableSearch.form.noticeDateEnd) {
        return date.getTime() >= moment(this.$refs.tableSearch.form.noticeDateEnd).valueOf()
      }
    },
    disabledDateEnd(date) {
      if (this.$refs.tableSearch.form.noticeDateStart) {
        return date.getTime() <= moment(this.$refs.tableSearch.form.noticeDateStart).valueOf()
      }
    },
    submitSearch(val) {
    },
    resetSearch(val) {
    },
  },
}
</script>
<style lang="scss" scoped>
.page-content {
  height: 100%;
  margin-right: 0;
  .page-header {
    margin-bottom: 0 !important;
    .search {
      margin-top: 0 !important;
    }
  }
  .page-body {
    padding: 0 16px !important;
    /deep/ .el-table {
      height: calc(100% - 90px) !important;
    }
  }
}
/deep/ .el-pagination {
  text-align: center;
}

/deep/ .el-range-editor.el-input__inner {
  box-sizing: border-box;
  height: 32px;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/portal/search/detail/CourseNotice.vue